import { useCallback, useState } from 'react';

export const useProductInformationPanel = () => {
  const [quantity, setQuantity] = useState(1);
  const [isImageEnlarged, setIsImageEnlarged] = useState(false);
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);

  const handleImageClick = useCallback(() => {
    setIsImageEnlarged(true);
  }, []);

  const handleCloseEnlargedImage = useCallback(() => {
    setIsImageEnlarged(false);
  }, []);

  const handleReadMoreClick = useCallback(() => {
    setIsDescriptionExpanded(true);
  }, []);

  const handleCloseDescription = useCallback(() => {
    setIsDescriptionExpanded(false);
  }, []);

  return {
    quantity,
    setQuantity,
    isImageEnlarged,
    isDescriptionExpanded,
    handleImageClick,
    handleCloseEnlargedImage,
    handleReadMoreClick,
    handleCloseDescription,
  };
};
